

export const defaultConfiguration = {
    "workCycleDuration": 1800000,
    "pauseCycleDuration": 300000,


    // "workCycleDuration": 4000,
    // "pauseCycleDuration": 4000,

    "cycles": 4,
    "playlists": {
        "work": [
            {
                "id": "mhNg55_IYiw",
                "url": "https://www.youtube.com/watch?v=mhNg55_IYiw",
                "title": "Music for Work — Deep Focus Mix for Programming, Coding",
                "apiData": {
                    "kind": "youtube#video",
                    "etag": "_-2fNBvR7jQtPc4tYWOprWdR358",
                    "id": "mhNg55_IYiw",
                    "snippet": {
                        "publishedAt": "2024-08-27T11:00:25Z",
                        "channelId": "UC8oFp3qO3ocmiy7rtjizWBQ",
                        "title": "Music for Work — Deep Focus Mix for Programming, Coding",
                        "description": "Dive into a realm of deep focus with our mix designed specifically for programming and coding. The subtle rhythms and ambient tones provide the perfect sonic landscape to keep your mind sharp and your work flowing smoothly. Whether you're solving complex algorithms or developing the next big app, let these tracks enhance your concentration and drive your creativity.\n\n🌞 For contact and submit music: lofi@entstella.com\n\n©️ All content on Chill Flow is protected by copyright\n© All music and videos are produced by us and are copyrighted \n✔ All rights belong to their respective owners\n\nMusic for Work — Deep Focus Mix for Programming, Coding\nMusic for Work — Deep Focus Mix for Programming, Coding\nMusic for Work — Deep Focus Mix for Programming, Coding\n\n#ProgrammingMusic #CodingMusic #HackingMusic",
                        "thumbnails": {
                            "default": {
                                "url": "https://i.ytimg.com/vi/mhNg55_IYiw/default.jpg",
                                "width": 120,
                                "height": 90
                            },
                            "medium": {
                                "url": "https://i.ytimg.com/vi/mhNg55_IYiw/mqdefault.jpg",
                                "width": 320,
                                "height": 180
                            },
                            "high": {
                                "url": "https://i.ytimg.com/vi/mhNg55_IYiw/hqdefault.jpg",
                                "width": 480,
                                "height": 360
                            },
                            "standard": {
                                "url": "https://i.ytimg.com/vi/mhNg55_IYiw/sddefault.jpg",
                                "width": 640,
                                "height": 480
                            },
                            "maxres": {
                                "url": "https://i.ytimg.com/vi/mhNg55_IYiw/maxresdefault.jpg",
                                "width": 1280,
                                "height": 720
                            }
                        },
                        "channelTitle": "Chill Flow",
                        "tags": [
                            "coding music",
                            "background music",
                            "programming music",
                            "focus music",
                            "music for work",
                            "future garage",
                            "electronic music",
                            "future garage mix",
                            "music for programming",
                            "downtempo music",
                            "downtempo",
                            "chillstep",
                            "chillstep mix",
                            "work music",
                            "study music",
                            "ambient music",
                            "productivity music",
                            "concentration music",
                            "atmospheric music",
                            "deep work music",
                            "music lab",
                            "chill work music",
                            "productive music",
                            "chillout",
                            "concentration music for work",
                            "motivational music",
                            "музыка для работы",
                            "creative flow"
                        ],
                        "categoryId": "10",
                        "liveBroadcastContent": "none",
                        "localized": {
                            "title": "Music for Work — Deep Focus Mix for Programming, Coding",
                            "description": "Dive into a realm of deep focus with our mix designed specifically for programming and coding. The subtle rhythms and ambient tones provide the perfect sonic landscape to keep your mind sharp and your work flowing smoothly. Whether you're solving complex algorithms or developing the next big app, let these tracks enhance your concentration and drive your creativity.\n\n🌞 For contact and submit music: lofi@entstella.com\n\n©️ All content on Chill Flow is protected by copyright\n© All music and videos are produced by us and are copyrighted \n✔ All rights belong to their respective owners\n\nMusic for Work — Deep Focus Mix for Programming, Coding\nMusic for Work — Deep Focus Mix for Programming, Coding\nMusic for Work — Deep Focus Mix for Programming, Coding\n\n#ProgrammingMusic #CodingMusic #HackingMusic"
                        },
                        "defaultAudioLanguage": "en-US"
                    },
                    "statistics": {
                        "viewCount": "282205",
                        "likeCount": "2797",
                        "favoriteCount": "0",
                        "commentCount": "57"
                    }
                }
            }
        ],
        "pause": [
            {
                "id": "wz1ca1-_-MY",
                "url": "https://www.youtube.com/watch?v=wz1ca1-_-MY",
                "title": "System Of A Down - Bounce (Official Audio)",
                "apiData": {
                    "kind": "youtube#video",
                    "etag": "PS4cKyso0DDzS5Vv9VD9cJ0Csvw",
                    "id": "wz1ca1-_-MY",
                    "snippet": {
                        "publishedAt": "2016-04-29T22:02:18Z",
                        "channelId": "UCvtZDkeFxMkRTNqfqXtxxkw",
                        "title": "System Of A Down - Bounce (Official Audio)",
                        "description": "Official audio for ”Bounce” by System of a Down\nListen to System of a Down: https://SystemOfADown.lnk.to/listenYD\nSubscribe to the official System of a Down YouTube channel: https://SystemOfADown.lnk.to/subscribeYD\nWatch more System of a Down videos: https://SystemOfADown.lnk.to/listenYC/youtube\n\nFollow System of a Down:\nFacebook: https://SystemOfADown.lnk.to/followFI\nInstagram: https://SystemOfADown.lnk.to/followII\nTwitter: https://SystemOfADown.lnk.to/followTI\nWebsite: https://SystemOfADown.lnk.to/followWI\nSpotify: https://SystemOfADown.lnk.to/followSI\n\nLyrics:\nJump! (Pogo, pogo, pogo, pogo, pogo, pogo, pogo)\nBounce! (Pogo, pogo, pogo, pogo, pogo, pogo, pogo)\nDown! (Pogo, pogo, pogo) Up! (Pogo, pogo, pogo)\nJump! (Pogo) Bounce! (Pogo) Up! (Pogo) Down! (Pogo)\n\n#SystemOfADown #Bounce #Toxicity #HeavyMetal #HardRock",
                        "thumbnails": {
                            "default": {
                                "url": "https://i.ytimg.com/vi/wz1ca1-_-MY/default.jpg",
                                "width": 120,
                                "height": 90
                            },
                            "medium": {
                                "url": "https://i.ytimg.com/vi/wz1ca1-_-MY/mqdefault.jpg",
                                "width": 320,
                                "height": 180
                            },
                            "high": {
                                "url": "https://i.ytimg.com/vi/wz1ca1-_-MY/hqdefault.jpg",
                                "width": 480,
                                "height": 360
                            },
                            "standard": {
                                "url": "https://i.ytimg.com/vi/wz1ca1-_-MY/sddefault.jpg",
                                "width": 640,
                                "height": 480
                            },
                            "maxres": {
                                "url": "https://i.ytimg.com/vi/wz1ca1-_-MY/maxresdefault.jpg",
                                "width": 1280,
                                "height": 720
                            }
                        },
                        "channelTitle": "systemofadownVEVO",
                        "tags": [
                            "bounce system of a down",
                            "system of a down bounce",
                            "bounce",
                            "system of a down",
                            "soad bounce",
                            "system of a down pogo",
                            "pogo system of a down",
                            "bounce soad",
                            "soad pogo",
                            "soad",
                            "system of a down jump",
                            "pogo stick system of a down",
                            "system of down bounce",
                            "jump system of a down",
                            "system of down",
                            "pogo soad",
                            "bounce pogo pogo pogo",
                            "soad jump",
                            "toxicity soad",
                            "toxicity system of a down",
                            "chop suey system of a down",
                            "toxicity",
                            "byob soad",
                            "lonely day system of a down"
                        ],
                        "categoryId": "10",
                        "liveBroadcastContent": "none",
                        "localized": {
                            "title": "System Of A Down - Bounce (Official Audio)",
                            "description": "Official audio for ”Bounce” by System of a Down\nListen to System of a Down: https://SystemOfADown.lnk.to/listenYD\nSubscribe to the official System of a Down YouTube channel: https://SystemOfADown.lnk.to/subscribeYD\nWatch more System of a Down videos: https://SystemOfADown.lnk.to/listenYC/youtube\n\nFollow System of a Down:\nFacebook: https://SystemOfADown.lnk.to/followFI\nInstagram: https://SystemOfADown.lnk.to/followII\nTwitter: https://SystemOfADown.lnk.to/followTI\nWebsite: https://SystemOfADown.lnk.to/followWI\nSpotify: https://SystemOfADown.lnk.to/followSI\n\nLyrics:\nJump! (Pogo, pogo, pogo, pogo, pogo, pogo, pogo)\nBounce! (Pogo, pogo, pogo, pogo, pogo, pogo, pogo)\nDown! (Pogo, pogo, pogo) Up! (Pogo, pogo, pogo)\nJump! (Pogo) Bounce! (Pogo) Up! (Pogo) Down! (Pogo)\n\n#SystemOfADown #Bounce #Toxicity #HeavyMetal #HardRock"
                        },
                        "defaultAudioLanguage": "en-US"
                    },
                    "statistics": {
                        "viewCount": "9032015",
                        "likeCount": "100754",
                        "favoriteCount": "0",
                        "commentCount": "3650"
                    }
                }
            }
        ]
    }
}